var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M721,5.8H79.3C38.5,5.8,5.1,39.2,5.1,80v641.6c0,40.8,33.4,74.2,74.2,74.2H721c40.8,0,74.2-33.4,74.2-74.2V80\n\tC795.1,39.2,761.8,5.8,721,5.8z M373.6,524.4H203.5V290.1h56.1V475h114V524.4z M598.8,524.4h-42.7l-1.8-26.1\n\tc-15.5,20.5-38.8,30.4-72.7,30.4c-70.2,0-113.3-46.2-113.3-122.1c0-75.2,49.1-120.3,121.4-120.3c52.9,0,95.3,26.5,106.6,72.7\n\tl-55.1,8.1c-4.9-17.6-21.9-33.5-52.2-33.5c-34.6,0-61.4,22.9-61.4,73.1s25.1,74.8,62.5,74.8c25.8,0,52.6-9.9,52.6-39.9v-3.5h-57.2\n\tV392h113.3V524.4z"}));
}

Icon.defaultProps = {"version":"1.1","id":"logo-svg","x":"0px","y":"0px","viewBox":"0 0 800 800","style":{"enableBackground":"new 0 0 800 800"},"xmlSpace":"preserve"};

module.exports = Icon;

Icon.default = Icon;
